/**
 * Selector for finding visible and accessible focusable elements within a container.
 * Excludes elements that are disabled, hidden, or marked with aria-hidden="true".
 * Use this for normal focus management scenarios where you want to find elements
 * that should be focusable in the current context.
 */
export const VISIBLE_FOCUSABLE_ELEMENTS_SELECTOR = [
  'button:not([disabled]):not([aria-hidden="true"])',
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden="true"])',
  'select:not([disabled]):not([aria-hidden="true"])',
  'textarea:not([disabled]):not([aria-hidden="true"])',
  'a[href]:not([aria-hidden="true"])',
  '[tabindex]:not([tabindex="-1"]):not([aria-hidden="true"])',
  '[contenteditable="true"]:not([aria-hidden="true"])',
].join(', ');

/**
 * Selector for finding ALL focusable elements within a container, including hidden ones.
 * Does not exclude elements with aria-hidden="true" or other visibility attributes.
 * However, it still excludes inputs that are inherently not focusable (e.g., type="hidden").
 * Use this when you need to find all potentially focusable elements, for example
 * when making elements unfocusable in offscreen content or managing focus traps.
 */
export const ALL_FOCUSABLE_ELEMENTS_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
  '[role="button"]:not([disabled]):not([tabindex="-1"])',
].join(', ');

export const FOCUSABLE_ELEMENTS_SELECTOR = VISIBLE_FOCUSABLE_ELEMENTS_SELECTOR;
